import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { ApiService } from '../../shared/services/api-service/api-service';
import * as careerPathActions from '../actions/career-path-actions';
import * as studentPathActions from '../actions/student-paths-actions';
import { IStudentPathCreatePayload } from '../actions/student-paths-actions';

@Injectable()
export class CareerPathEffects {
  constructor(private actions$: Actions, private apiService: ApiService, private store$: Store<any>) {}

  @Effect()
  loadCareerPath$ = this.actions$.pipe(
    ofType(careerPathActions.LOAD_CAREER_PATH),
    switchMap((action: { type: string; payload: any }) => {
      const { schoolId, pathType } = action.payload;
      return this.apiService.getPaths(schoolId, pathType).pipe(
        switchMap(paths => [new careerPathActions.LoadCareerPathSuccess(paths)]),
        catchError(error => of(new careerPathActions.LoadCareerPathFail(error))),
      );
    }),
  );

  // todo: add spec. need to figure out how to handle multiple actions (dvn)
  /* istanbul ignore next */
  @Effect()
  createCareerPath$ = this.actions$.pipe(
    ofType(careerPathActions.CREATE_CAREER_PATH),
    switchMap((action: any) => {
      const { schoolId, pathType, studentId, payload } = action.payload;
      return this.apiService.createPath(schoolId, pathType, payload).pipe(
        mergeMap((path: any) => {
          const payload: IStudentPathCreatePayload = {
            schoolId,
            studentId,
            pathId: path._id,
          };
          return [
            new careerPathActions.CreateCareerPathSuccess(path),
            new studentPathActions.CreateStudentPath(payload),
          ];
        }),
        catchError(error => {
          return of(new careerPathActions.CreateCareerPathFail(error));
        }),
      );
    }),
  );
}
